/* eslint no-unused-vars: "warn" */
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Login from "layouts/Login";
import * as Actions from "actions/actions";

const mapStateToProps = state => ({
  tokens: state.tokens,
  language: state.language,
  firstRestaurant: state.firstRestaurant
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

const LoginContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.js